import { Component, ElementRef, OnInit, QueryList, ViewChildren, AfterViewInit, HostListener, Inject } from '@angular/core';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthUser } from 'src/app/models/auth/AuthUser';
import { RolesEnum } from 'src/app/models/users/roles/enums/roles';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { MessagingService } from 'src/app/services/messaging.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit, AfterViewInit {
  actions = RolesEnum;
  language = localStorage.getItem('language') || 'en';
  currentUser = new AuthUser();
  @ViewChildren('navRoutes') navRoutes!: QueryList<ElementRef>;
  activeLink: string = 'Home';
  openSideNav = false;
  fixedTab = false;
  unSeenNotificationsCount = 0;
  notifLoading = false;
  notificationsList: Array<any> = [];

  constructor(
    public translate: TranslateService,
    private translationService: TranslationService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private messagingService: MessagingService
  ) {
    router.events.subscribe((event: RouterEvent | any) => {
      this.navigationInterceptor(event);
    });
  }

  ngOnInit() {
    this.messagingService.requestPermission();
    this.messagingService.receiveMessage();
    this.authenticationService.currentUserSubject.subscribe((user: AuthUser) => {
      this.currentUser = user;
    });
    this.messagingService.currentMessage.subscribe(res => {
      if (res) {
        this.unSeenNotificationsCount += 1;
      }
      // console.log(res)
    }, err => {
      // console.log('dds')
    })
  }

  // Notifications
  openNotificationPanel() {
    this.unSeenNotificationsCount = 0;
    // this.notificationsResult.unSeenNotificationsCount = 0;
    this.getNotifications();
  }

  getNotifications(update = null) {
    this.messagingService.getNotifications(null).subscribe(
      (result: any) => {
        this.notificationsList = result as any;
        this.notifLoading = false;
      }, (err: any) => {
        this.notifLoading = false;
        console.error(err);
      });
  }

  // Actions
  changeLanguage(lang: string) {
    this.translationService.setLanguage(lang);
    window.location.reload();
  }

  logout() {
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }

  hasPermission(permission: string) {
    return this.authenticationService.hasPermission(permission);
  }

  changeActiveRoute(routeName: string) {
    this.activeLink = this.translate.instant(routeName);;
  }

  ngAfterViewInit(): void {
    // console.log(this.activeLink)
    setTimeout(() => {
      this.activeLink = this.navRoutes.find(ele => ele.nativeElement.classList.contains('active'))?.nativeElement.text;
    }, 10);
  }

  showSideNav() {
    this.openSideNav = true;
  }

  closeSidenav(e: any) {
    this.openSideNav = false;
  }

  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationEnd) {
      setTimeout(() => { // here
        this.activeLink = this.navRoutes.find(ele => ele.nativeElement.classList.contains('active'))?.nativeElement.text;
      }, 10);
    }
  }

  @HostListener('window:scroll', ['$event']) onScrollEvent($event: any) {
    const pageOffset = window.pageYOffset;
    const heightHeader = (document.getElementsByClassName('app-mian-header')[0].clientHeight / 4);
    this.fixedTab = pageOffset > heightHeader;
  }

}
